function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import classNames from 'classnames';
import styles from './styles.module.scss';
import SortSelect from '@profile/src/Components/SortSelect_V2';
import SearchResult from './SearchResult';
import { useTypedSelector } from '@profile/src/redux/utils';
import { makeSelectCurrentItemData } from './SearchResult/selectors';
import { HeroStatus } from '@profile/src/utils/types';
import HeaderTab, { ButtonType } from './Components/HeaderTab';
import useParamsRoute from '@profile/src/hooks/useRouteParams';
import { TestableProvider, useTestId } from '@wolffun/testable-id';

const HeroTab = ({
  className
}) => {
  const {
    generateTestIdProps
  } = useTestId();
  const items = useTypedSelector(makeSelectCurrentItemData);
  const ref = React.useRef(null);
  const {
    status,
    own
  } = useParamsRoute();
  const buttonStatus = status === HeroStatus.RENTED && own === 'true' ? ButtonType.RENTED_OUT : ButtonType.AVAILABLE;

  const onSortChanged = sortBy => {
    switch (sortBy) {
      case HeroStatus.RENTED_OUT.toString():
        {
          var _ref$current;

          (_ref$current = ref.current) === null || _ref$current === void 0 ? void 0 : _ref$current.onFetch({
            page: 1,
            status: HeroStatus.RENTED.toString(),
            own: true
          });
          return;
        }

      case HeroStatus.RENTED.toString():
        {
          var _ref$current2;

          (_ref$current2 = ref.current) === null || _ref$current2 === void 0 ? void 0 : _ref$current2.onFetch({
            page: 1,
            status: HeroStatus.RENTED.toString(),
            own: false
          });
          return;
        }

      default:
        {
          var _ref$current3;

          (_ref$current3 = ref.current) === null || _ref$current3 === void 0 ? void 0 : _ref$current3.onFetch({
            page: 1,
            status: sortBy
          });
          return;
        }
    }
  };

  const onTabChange = state => {
    if (state === ButtonType.RENTED_OUT) {
      var _ref$current4;

      (_ref$current4 = ref.current) === null || _ref$current4 === void 0 ? void 0 : _ref$current4.onFetch({
        page: 1,
        status: HeroStatus.RENTED.toString(),
        own: true
      });
    } else {
      var _ref$current5;

      (_ref$current5 = ref.current) === null || _ref$current5 === void 0 ? void 0 : _ref$current5.onFetch({
        page: 1
      });
    }
  };

  return /*#__PURE__*/React.createElement(TestableProvider, {
    testId: "hero"
  }, /*#__PURE__*/React.createElement("div", {
    className: classNames(styles.container, className)
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.header
  }, /*#__PURE__*/React.createElement(HeaderTab, {
    status: buttonStatus,
    onChange: onTabChange
  }), /*#__PURE__*/React.createElement(SortSelect, _extends({}, generateTestIdProps('hero', 'dropdown-list'), {
    className: styles.sort,
    placeholder: "Filter by...",
    options: [{
      label: 'All items',
      dataTestId: 'all-item'
    }, {
      id: HeroStatus.AVAILABLE.toString(),
      label: 'For sale',
      dataTestId: 'for-sale'
    }, {
      id: HeroStatus.ON_MARKET.toString(),
      label: 'Selling',
      dataTestId: 'selling'
    }, {
      id: [HeroStatus.IN_TRANSACTION_PROCESS, HeroStatus.PREPARE_LENDING, HeroStatus.PREPARE_SELLING, HeroStatus.PREPARE_UNLOCKING, HeroStatus.MINTING, HeroStatus.USER_MINTING].join(','),
      label: 'Processing',
      dataTestId: 'processing'
    }, {
      dataTestId: 'locked',
      id: HeroStatus.HS_RENTED_RELEASED.toString(),
      label: 'Locked'
    }, {
      id: HeroStatus.RENTED.toString(),
      label: 'Rented',
      dataTestId: 'rented'
    }, {
      id: HeroStatus.RENTED_OUT.toString(),
      label: 'Rented Out',
      dataTestId: 'rented-out'
    }, {
      id: HeroStatus.FOR_RENT.toString(),
      label: 'For Rent',
      dataTestId: 'for-rent'
    }, {
      id: HeroStatus.FUSING.toString(),
      label: 'Fusion',
      dataTestId: 'fusion'
    }, {
      id: [HeroStatus.NOT_MINT, HeroStatus.USER_NOT_MINT].join(','),
      label: 'Not mint',
      dataTestId: 'not-mint'
    }],
    onSelect: onSortChanged
  }))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", {
    className: styles.label
  }, "Heroes: ", /*#__PURE__*/React.createElement("span", null, items.length))), /*#__PURE__*/React.createElement(SearchResult, {
    ref: ref
  })));
};

export default HeroTab;